<template>
  <div id="app" :style='`direction: ${$i18n.locale === "en"? "ltr":"rtl"}; margin: ${isEezee || isRedbull ? "0px" : "10px"}`'>

    <div v-if="$store.state.loading">
      <z-loading :active="$store.state.loading"  :is-full-page="true"/>
    </div>
    <template v-else>
      <div v-if="isEmbed && !$store.state.embedAuth">Not Authorized</div>

      <router-view v-if="!isEmbed || (isEmbed && $store.state.embedAuth)" />

    </template>

  <div v-if="isEezee || isRedbull">
    <EezeeFooter />
  </div>
  </div>
</template>

<script>
import EezeeFooter from "@/components/eezee/EezeeFooter.vue";
import ZLoading from "@/zain-component-library/src/lib-components/ZLoading.vue";

export default {
  name: 'App',
  components: {ZLoading, EezeeFooter},
  computed: {
    isEmbed () {
      return ['/upload' , '/scan'].some(x => this.$route.path.startsWith(x))
    },
    isEezee () {
      return this.$route.path.startsWith('/eezee')
    },
    isRedbull () {
      return this.$route.path.startsWith('/rbmz')
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
